module.exports = __webpack_public_path__ + "static/media/caravan-alt.c64c5298.svg";